var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "viewer-fade" } }, [
    _vm.visible
      ? _c(
          "div",
          {
            ref: "gl-pdf-viewer__wrapper",
            staticClass: "gl-pdf-viewer__wrapper",
            attrs: { tabindex: "-1" },
          },
          [
            _c("div", { staticClass: "gl-pdf-viewer__header clearfix" }, [
              _vm.staticFile
                ? _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.pdfUrl)),
                  ])
                : _c("div", { staticClass: "title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "gl-pdf-viewer__mask" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "gl-pdf-viewer__btn gl-pdf-viewer__close",
                on: { click: _vm.hide },
              },
              [_c("i", { staticClass: "el-icon-circle-close" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "pdfView",
                staticClass: "gl-pdf-viewer__canvas",
                attrs: { id: "pdfView" },
              },
              [
                _vm.staticFile
                  ? _c("iframe", {
                      attrs: {
                        id: "previewPdfStatic",
                        src:
                          "./pdf/web/viewer.html?file=/static/pdf/" +
                          _vm.pdfUrl,
                        height: "100%",
                        width: "60%",
                      },
                    })
                  : _c("iframe", {
                      attrs: {
                        id: "previewPdf",
                        src:
                          "./pdf/web/viewer.html?file=" +
                          encodeURIComponent(_vm.pdfUrl + "#" + _vm.title),
                        height: "100%",
                        width: "60%",
                      },
                    }),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }